<template>
  <SectionHeader title="Parking" imgSrc="parking/parking-titlebg.jpeg" />
  <div class="parking"><h2>PLACEHOLDER FOR PARKING INFO</h2></div>
</template>

<script>
import SectionHeader from "@/components/SectionHeader.vue";

export default {
  name: "Parking",
  components: {
    SectionHeader,
  },
};
</script>

<style lang="scss" scoped>
.parking {
  position: relative;
  display: flex;
  height: 400px;
  justify-content: center;
  align-items: center;
  h2 {
    font-family: Formula1-Display-Bold;
    font-size: 20px;
    color: #008e97;
    line-height: 45px;
    font-weight: 500;
  }
}
</style>